import FormattedAddress from "components/Atoms/FormattedAddress";
import React from "react";

interface Props {
  customer: server.dto.BusinessCentralCustomer
}

const BusinessCentralCustomer = (props: Props) => {
  if (props.customer == null) return <div className="ui message red">{RESX.BusinessCentral.CouldNotFindItemInBusinessCentral}</div>;

  return <div className="flex-column gap-small">
    <div>
      <h3>{props.customer.name}</h3>
    </div>

    <div>
      <FormattedAddress address={props.customer.address} />
    </div>

    {props.customer.vatNumber && <div>{props.customer.vatNumber}</div>}
  </div>;
};

export default BusinessCentralCustomer;